import { styled } from '@mui/material';
import { TreeItem } from '@mui/x-tree-view';
import React from 'react';

const StyTreeItem = styled(TreeItem, {
    name: 'StyTreeItem',
})({
    '.MuiTreeItem-content': {
        '&.Mui-focused, &.Mui-selected, :hover': {
            backgroundColor: 'transparent',
        },
    },
});

type Props = {
    filiere: string;
    children?: React.ReactNode;
};

export default function OfficialGradeTreeItem({ filiere, children }: Props) {
    return (
        <StyTreeItem
            nodeId={`filiere-${filiere}`}
            label={filiere}
            key={filiere}
        >
            {children}
        </StyTreeItem>
    );
}
